import { render } from "./checkPayment.vue?vue&type=template&id=257fefb6&scoped=true"
import script from "./checkPayment.vue?vue&type=script&lang=js"
export * from "./checkPayment.vue?vue&type=script&lang=js"

import "./checkPayment.vue?vue&type=style&index=0&id=257fefb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-257fefb6"

export default script